













import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import StyledSelectDefaultView from './StyledSelectDefaultView.vue';
import { PageMetadataDto, PageRequestDto } from '@/api';
import { TranslateResult } from 'vue-i18n';
import * as _ from 'lodash';

@Component({
  components: {StyledSelectDefaultView},
})
export default class ShowMorePagination extends Vue {
  @Model('change', {required: true})
  public pageRequest!: PageRequestDto;

  @Prop({required: true})
  public currentResultCount!: number;

  @Prop({required: true})
  public currentPage!: PageMetadataDto;

  get progressDisplayString(): TranslateResult {
    const current = this.currentResultCount;
    const total = this.currentPage?.totalElements ?? 0;
    return this.$t('message.search.pagination.currentProgress', {current, total});
  }

  get hasNextPage(): boolean {
    return this.currentPage?.number < (this.currentPage?.totalPages - 1);
  }

  get progressPercentString(): string {
    if (!this.currentPage.totalElements) {
      return '0%';
    } else {
      const ratio = this.currentResultCount / this.currentPage.totalElements;
      return `${ratio * 100}%`;
    }
  }

  public requestNext() {
    const changedPage = _.cloneDeep(this.pageRequest);
    changedPage.page = (changedPage.page ?? 0) + 1;
    this.$emit('change', changedPage);
  }
}
